import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
// 客服中心 路由表
export default [{
  path: "/serviceCenter/complaint",
  //投诉建议
  component: function component() {
    return import("../../../views/serviceCenter/complaint/complaint.vue");
  },
  name: "complaintIndex",
  meta: {
    title: "投诉建议",
    foot: false
  }
}, {
  path: "/serviceCenter/complaintList",
  //我的投诉
  component: function component() {
    return import("../../../views/serviceCenter/complaintList/complaintList.vue");
  },
  name: "complaintList",
  meta: {
    title: "我的投诉",
    foot: false
  }
}];